import { observer } from 'mobx-react';
import { FC, useEffect, useMemo } from 'react';
import { Prompt } from 'react-router';
import ConsumerChannelsConfigSkeletons from '../../containers/ConsumerChannelsConfigSkeletons/ConsumerChannelsConfigSkeletons';
import ConsumerChannelsConfigHeader from '../../containers/ConsumerChannelsConfigHeader/ConsumerChannelsConfigHeader';
import { CONSUMER_CHANNEL_CONFIGURATION_SCREEN, CONSUMER_CHANNEL_CONFIG_CRUMB } from '../ConsumerChannelsConfigScreen/constants';
import consumerChannelsConfigStore from '../ConsumerChannelsConfigScreen/store';
import WebConfigColorsTab from './containers/WebConfigColorsTab/WebConfigColorsTab';
import WebConfigConfigurationTab from './containers/WebConfigConfigurationTab/WebConfigConfigurationTab';
import WebConfigImagesTab from './containers/WebConfigImagesTab/WebConfigImagesTab';
import configWebStore from './stores';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import TabList from 'src/view/components/Tabs/TabList';
import { getPromptProps } from 'src/view/components/CustomPrompt/helper';
import Button from 'src/view/components/Controls/ButtonComponent/Button';
import { localeStore } from 'src/mobx/localesStore';
import { BUTTON_TITLE } from 'src/constants/main';

const WebConfigScreen: FC = observer((): JSX.Element => {
  useEffect(() => {
    return () => configWebStore.clearStore();
  }, []);

  const tabs = useMemo((): CONSUMER_CHANNEL_CONFIG_CRUMB[] => {
    return [CONSUMER_CHANNEL_CONFIG_CRUMB.COLORS, CONSUMER_CHANNEL_CONFIG_CRUMB.IMAGES, CONSUMER_CHANNEL_CONFIG_CRUMB.CONFIGURATION];
  }, []);

  const isSaveBtn = useMemo((): boolean => {
    return consumerChannelsConfigStore.isNoColorsCrumb(CONSUMER_CHANNEL_CONFIGURATION_SCREEN.WEB);
  }, [consumerChannelsConfigStore.navigationCrumbs[CONSUMER_CHANNEL_CONFIGURATION_SCREEN.WEB]]);

  return (
    <div className="d-flex flex-column flex-1">
      <ScrollableBlock showScrollbar scrollbarSize="normal" className="flex-1 mt-6" scrollClassName="d-flex flex-column">
        <ConsumerChannelsConfigHeader screen={CONSUMER_CHANNEL_CONFIGURATION_SCREEN.WEB} />

        {consumerChannelsConfigStore.isFirstLoading ? (
          <ConsumerChannelsConfigSkeletons colorsRowNumber={7} includeCssBlock />
        ) : (
          <TabList value={consumerChannelsConfigStore.navigationCrumbs.web} tabs={tabs}>
            <WebConfigColorsTab />
            <WebConfigImagesTab />
            <WebConfigConfigurationTab />
          </TabList>
        )}

        {isSaveBtn && <Button title={localeStore.t(BUTTON_TITLE.SAVE)} onClick={configWebStore.submit} className="mt-8" />}
      </ScrollableBlock>

      <Prompt when={configWebStore.isEdit} message={getPromptProps()} />
    </div>
  );
});

export default WebConfigScreen;
